<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <form v-on:submit.prevent="">
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-6">
                        <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="1" checked type="radio"><span>مشتری حقیقی</span></label>
                    </div>
                    <div class="col-lg-2 col-md-3 col-6">
                        <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="2" type="radio"><span>مشتری حقوقی</span></label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-xxl-3 col-xl-4">
                        <form v-on:submit.prevent="searchCustomer">
                            <label for="national-code">کد ملی/شناسه ملی</label>
                            <div class="input-group">
                                <input class="form-control text-left" :maxlength="maxLength" id="national-code" type="tel" v-model="nationalCode">
                                <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit" :disabled="(customerType == 1 && nationalCode.length != 10) || (customerType == 2 && nationalCode.length != 11)"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                            </div>
                        </form>
                    </div>
                    <div class="col-12 mt-2" v-if="registerUser">
                        <hr>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>نام</label>
                                    <input type="text" class="form-control" v-model="userFirstName">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>نام خانوادگی</label>
                                    <input type="text" class="form-control" v-model="userLastName">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>کد ملی</label>
                                    <input type="tel" class="form-control" v-model="userNationalCode" v-mask="'##########'">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>شماره همراه</label>
                                    <input type="tel" class="form-control" v-model="userPhone" v-mask="'09##-#######'">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>تاریخ تولد</label>
                                    <Datepicker locale="fa" :auto-submit="true" v-model="userBirthdate" :locale-config="{
                                        fa: {
                                            displayFormat: 'jYYYY/jMM/jDD',
                                            lang: {label: 'شمسی'}
                                        }
                                    }"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <button class="btn btn-success" @click="registerNewUser" :disabled="userFirstName == '' || userLastName == '' || userNationalCode == '' || userPhone == '' || userPhone.length != 12 || userBirthdate == ''" type="button">ایجاد مشتری جدید</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-4" v-if="registerOrganization">
                        <CreateOrganization :closed="true" />
                    </div>
                    <div class="col-12 mt-4" v-if="Object.keys(customerDetails).length || Object.keys(legalCustomerDetails).length">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover user-details-table">
                                <tbody v-if="customerType == 1">
                                    <tr>
                                        <td>نام:</td>
                                        <td>{{ customerDetails.firstName }}</td>
                                        <td>نام خانوادگی:</td>
                                        <td>{{ customerDetails.lastName }}</td>
                                    </tr>
                                    <tr>
                                        <td>شماره همراه:</td>
                                        <td>{{ customerDetails.mobile }}</td>
                                        <td>کد ملی:</td>
                                        <td>{{ customerDetails.nationalCode }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="customerType == 2">
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row mt-3" v-if="customerId && Object.keys(customerDetails).length || Object.keys(legalCustomerDetails).length">
                <div class="col-md-9">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" data-toggle="tab" @click="setCurrentTab('fizical-card')" href="#fizical-card">کارت هدیه فیزیکی آماده</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('fizical-fizical-card')" href="#fizical-fizical-card">کارت هدیه فیزیکی دلخواه</a>
                    </nav>
                    <div class="tab-content">
                        <div class="tab-pane active show" id="fizical-card">
                            <FizicalCard v-if="currentTab == 'fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                        <div class="tab-pane" id="fizical-fizical-card">
                            <CustomCard v-if="currentTab == 'fizical-fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card custom-card card-body tx-white-8 bg-success">
                        <h6>اطلاعات حساب بانکی</h6>
                        <hr class="mb-4 mt-2">
                        <p>شماره حساب :</p>
                        <code class="bg-white p-2 rounded text-center">129-813-986404-1</code>
                        <p class="mt-3">شماره شبا :</p>
                        <code class="bg-white p-2 rounded text-center">IR280690012981300986404001</code>
                    </div>
                    <div class="card custom-card card-body tx-white-8 bg-gray-800">
                        <h6>سبد خرید</h6>
                        <hr class="mb-4 mt-2">
                        <p v-if="!basket.length" class="text-center mb-0">سبد خرید خالی است</p>
                        <div v-else>
                            <div class="row mb-3" v-for="(card,index) in basket" :key="index">
                                <div class="col-md-4 pl-0">
                                    <img :src="!card.imageUrl.includes('base64') ? ('https://cardapi.sabinarya.com' + card.imageUrl) : card.imageUrl" class="w-100">
                                </div>
                                <div class="col-md-5">
                                    <p class="mb-1">{{ card.title }}</p>
                                    <p class="mb-1">تعداد: {{ card.itemsCount }}</p>
                                    <p class="mb-1">مبلغ شارژ: {{ card.deposit ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(card.deposit) : 0 }}</p>
                                </div>
                                <div class="col-md-3">
                                    <button class="btn ripple btn-danger btn-icon float-left" @click="removeCard(index)"><i class="fe fe-minus"></i></button>
                                </div>
                            </div>
                            <hr class="mt-2 mb-4">
                            <!-- <p>مجموع قیمت جسم کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(cardsPrice) }} ریال</p> -->
                            <p>مجموع قیمت شارژ کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(chargesPrice) }} ریال</p>
                            <button class="btn btn-success btn-block" v-if="chargesPrice == 0 && false" @click="submit">تایید و ثبت سفارش</button>
                        </div>
                    </div>
                    <div class="card custom-card card-body tx-white-8 bg-gray-900" v-if="basket.length > 0">
                        <h6>ثبت اطلاعات</h6>
                        <hr class="mb-4 mt-2">
                        <div class="row">
                            <div class="col-6">
                                <label class="rdiobox"><input v-model="printPlace" name="print-place" value="1" checked type="radio" disabled><span>چاپ در شعبه</span></label>
                            </div>
                            <div class="col-6">
                                <label class="rdiobox"><input v-model="printPlace" name="print-place" value="2" type="radio"><span>چاپ در سابین</span></label>
                            </div>
                        </div>
                        <div :class="`row ${printPlace == 2 ? 'mt-0' : 'mt-3'}`" v-if="printPlace == 2 && false">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>استان</label>
                                    <Vselect v-model="provinceId" :reduce="item => item.provinceId" label="title" :options="provinces">
                                        <div slot="no-options">مقداری یافت نشد</div>
                                    </Vselect>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>شهر</label>
                                    <Vselect v-model="cityId" :reduce="item => item.cityId" label="title" :options="cities">
                                        <div slot="no-options">مقداری یافت نشد</div>
                                    </Vselect>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>کد پستی</label>
                                    <input type="tel" class="form-control" v-mask="'##########'" v-model="postalCode">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>آدرس</label>
                                    <textarea type="tel" class="form-control" v-model="addressText"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12" v-if="false">
                                <div class="form-group">
                                    <label>شماره سند</label>
                                    <input type="tel" class="form-control ltr-input" v-model="paymentIdentifier" maxlength="30">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>شماره پیگیری</label>
                                    <input type="tel" class="form-control ltr-input" v-model="rrn">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>تصویر فیش واریزی</label>
                                    <div class="input-group file-browser">
                                        <input id="file-input" type="text" class="form-control border-left-0 browse-file" placeholder="انتخاب کنید" readonly="">
                                        <label class="input-group-btn">
                                            <span class="btn btn-primary">
                                                انتخاب <input type="file" style="display: none;" accept="image/jpeg" @change="setFile">
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success btn-block mt-4" @click="submit" :disabled="!rrn || !file">تایید و ثبت سفارش</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FizicalCard from './Cards/FizicalCard';
import CustomCard from './Cards/CustomCard';
import CreateOrganization from '../Admin/Organization/Create';
export default {
    name: 'Create',
    components: {FizicalCard,CustomCard,CreateOrganization},
    data(){
        return {
            customerType: 1,
            nationalCode: '',
            maxLength: 10,
            customerDetails: {},
            legalCustomerDetails: {},
            customerId: 0,
            basket: [],
            currentTab: 'fizical-card',
            discount: 0,
            depositsList: [],
            cardsPrice: 0,
            chargesPrice: 0,
            totalPrice: 0,
            displayedTotalPrice: 0,
            showLoading: false,
            paymentIdentifier: '',
            orderId: 0,
            registerUser: false,
            registerOrganization: false,
            rrn: '',
            file: '',
            userFirstName: '',
            userLastName: '',
            userNationalCode: '',
            userPhone: '',
            userBirthdate: '',
            provinces: [],
            provinceId: '',
            cities: [],
            cityId: '',
            postalCode: '',
            addressText: '',
            justCustomCard: false,
            printPlace: 2
        }
    },
    watch: {
        discount: function(value){
            let discount = parseInt(value.toString().replace(/,/g,''));
            if(!this.discount)
                this.discount = 0;
            else if(this.totalPrice > discount)
                this.displayedTotalPrice = this.totalPrice - discount;
            else{
                this.discount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.totalPrice);
                this.displayedTotalPrice = 0;
            }
        },
        provinceId: function(value){
            this.cityId = '';
            if(value){
                this.$api.get('Shipping/Cities/' + value).then(({data}) => {
                    if(data.status)
                        this.cities = data.result;
                });
            }
        }
    },
    methods: {
        getData(){
            this.$api.get('Shipping/Provinces').then(({data}) => {
                if(data.status)
                    this.provinces = data.result;
            });
            this.$api.get('Cards/Deposits').then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    let deposits = data.result;
                    deposits.sort((a,b) => {
                        return a.depositValue - b.depositValue;
                    })
                    this.depositsList = deposits;
                }
            });
        },
        setCurrentTab(tab){
            this.currentTab = tab;
            this.rrn = '';
            this.paymentIdentifier = '';
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        registerNewUser(){
            this.showLoading = true;
            const postedData = {
                fistName: this.userFirstName,
                lastName: this.userLastName,
                nationalCode: this.userNationalCode,
                mobile: this.userPhone,
                birthDate: this.userBirthdate
            };
            this.$api.post('Branches/RegisterUser',postedData).then(({data}) => {
                if(data.status){
                    this.registerUser = false;
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'مشتری جدید با موفقیت ایجاد شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.nationalCode = this.userNationalCode;
                        this.userFirstName = '';
                        this.userLastName = '';
                        this.userNationalCode = '';
                        this.userPhone = '';
                        this.userBirthdate = '';
                        this.searchCustomer();
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            })
        },
        addToCard(themeId,title,cardType,itemsCount,price,imageUrl,showAmountOnCard,depositId,optionalCredit = null,metaData = [],imageMediaId = null){
            if(this.basket.length > 0){
                let existsDesign = this.basket[0].themeId == themeId;
                if(!existsDesign || themeId == 0){
                    this.$swal({
                        icon: 'error',
                        title: 'خطا',
                        text: 'شما نمی توانید بیشتر از یک طرح به سبد خرید خود اضافه کنید',
                        confirmButtonText: 'متوجه شدم'
                    });
                    return false;
                }
            }
            depositId = parseInt(depositId);
            let deposit = 0;
            if(depositId == 61 && optionalCredit){
                optionalCredit = parseInt(optionalCredit.replace(/,/g,''));
                deposit = optionalCredit;
            }else{
                let getDeposit = this.depositsList.filter(deposit => deposit.depositId == depositId)[0];
                if(getDeposit && depositId != 41)
                    deposit = getDeposit.depositValue;
                else
                    deposit = 0;
            }
            if(cardType == 1 || cardType == 2){
                let hasInBasket = this.basket.filter(item => item.themeId == themeId && item.cardType == cardType && item.depositId == depositId && (item.optionalCredit == optionalCredit || item.optionalCredit == 0));
                if(hasInBasket.length){
                    let findIndex = this.basket.findIndex(item => item == hasInBasket[0]);
                    this.basket[findIndex].itemsCount = parseInt(this.basket[findIndex].itemsCount) + parseInt(itemsCount);
                }
                else
                    this.basket.push({
                        themeId,
                        title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه مجازی' : 'کارت هدیه دلخواه')),
                        imageUrl,
                        showAmountOnCard: showAmountOnCard ? true : false,
                        itemsCount: parseInt(itemsCount),
                        price,
                        cardType,
                        depositId,
                        optionalCredit: depositId == 61 ? optionalCredit : 0,
                        deposit,
                        mediaId: imageMediaId,
                        metaDatas: metaData
                    });
            }else
                this.basket.push({
                    themeId,
                    title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه دلخواه' : 'کارت هدیه مجازی')),
                    imageUrl,
                    showAmountOnCard: showAmountOnCard ? true : false,
                    itemsCount: parseInt(itemsCount),
                    price,
                    cardType,
                    depositId,
                    optionalCredit: depositId == 61 ? optionalCredit : 0,
                    deposit,
                    mediaId: imageMediaId,
                    metaDatas: metaData
                });
            this.justCustomCard = true;
            this.basket.map(item => {
                if(item.cardType != 3)
                    this.justCustomCard = false;
            })
            this.calcTotalPrice();
        },
        calcTotalPrice(){
            let totalPrice = 0;
            let depositAmount = 0;
            this.chargesPrice = 0;
            this.cardsPrice = 0;
            let getDeposit;
            this.basket.map(item => {
                depositAmount = 0;
                if(item.depositId && item.depositId != 41){
                    if(item.depositId == 61)
                        depositAmount += (parseInt(item.optionalCredit) * item.itemsCount);
                    else{
                        getDeposit = this.depositsList.filter(deposit => deposit.depositId == item.depositId)[0];
                        depositAmount += (parseInt(getDeposit.depositValue) * item.itemsCount);
                    }
                }
                this.cardsPrice += (item.price * item.itemsCount);
                this.chargesPrice += depositAmount;
                totalPrice += (item.price * item.itemsCount) + depositAmount;
            });
            this.totalPrice = totalPrice;
            let discount = parseInt(this.discount.toString().replace(/,/g,''));
            if(totalPrice > discount)                
                this.displayedTotalPrice = totalPrice - discount;
            else
                this.displayedTotalPrice = 0;
        },
        searchCustomer(){
            this.registerUser = false;
            this.registerOrganization = false;
            this.basket = [];
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            const postedData = {
                company: this.customerType != 1,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    if(this.customerType == 1)
                        this.customerDetails = data.result;
                    else
                        this.legalCustomerDetails = data.result;
                    this.setCurrentTab('fizical-card');
                    this.customerId = data.result.customerId;
                }else{
                    if(this.customerType == 2)
                        this.registerOrganization = true;
                    else{
                        this.registerUser = true;
                        this.userNationalCode = this.nationalCode;
                    }
                }
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        discountNumberFormat(){
            let value = this.discount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        changeCustomerType(){
            this.registerUser = false;
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
        },
        submit(){
            this.showLoading = true;
            this.$swal({
                icon: 'warning',
                title: 'توجه !',
                text: 'آیا از ثبت سفارش اطمینان دارید ؟',
                confirmButtonText: 'ثبت سفارش',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then((result) => {
                if(result.isConfirmed){
                    const postedData = {
                        items: this.basket,
                        isAdmin: false,
                        printedatPlace: this.printPlace == 1,
                        customerId: this.customerId,
                        // paymentIdentifier: this.paymentIdentifier,
                        rrn: this.rrn,
                        base64Receipt: this.file
                    };
                    // console.log(postedData);
                    // if(this.printPlace == 2){
                    //     postedData.address = {
                    //         cityId: this.cityId,
                    //         postalCode: this.postalCode,
                    //         addressText: this.addressText
                    //     };
                    // }
                    this.$api.post('Branches/Orders',postedData).then(({data}) => {
                        if(data.status){
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text: 'ثبت سفارش شما با موفقیت انجام شد',
                                confirmButtonText: 'متوجه شدم'
                            }).then(() => {
                                if(this.printPlace == 1)
                                    this.$api.post('Branches/Printed',{orderId: this.orderId});
                                this.$router.push({path: '/?today=true'});
                            });
                        }
                    }).catch(({response}) => {
                        let html = '';
                        response.data.errors.map(err => html += err.message + '<br>');
                        this.$swal({
                            icon: 'error',
                            title: 'خطا !',
                            html
                        });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }else
                    this.showLoading = false;
            });
            
        },
        submitPayment(){
            this.showLoading = true;
            const paymentPostedData = {
                orderId: this.orderId,
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                // base64Receipt: this.file
            };
            this.$api.post('Branches/SubmitPayment',paymentPostedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت سفارش شما با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        if(this.printPlace == 1)
                            this.$api.post('Branches/Printed',{orderId: this.orderId});
                        this.$router.push({path: '/?today=true'});
                    });
            }).catch(({response}) => {
                let html = '';
                response.data.errors.map(err => html += err.message + '<br>');
                this.$swal({
                    icon: 'error',
                    title: 'خطا !',
                    html
                });
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>
